import { ConfigProvider, Dropdown, Input, MenuProps, Popover } from "antd";
import {
  SvgGPTSearch,
  SvgMagicVehicle,
  SvgVehicle,
  SvgClose,
  SvgSeachImg,
} from "ui/svgs";
import { DownOutlined, CloseOutlined, CheckOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import ImgSearchModalControl from "ui/alerts/img-search/img-search-modal-control";
type MenuItem = Required<MenuProps>["items"][number];
const vehicleColors = [
  { label: "red", color: "red" },
  { label: "pink", color: "rgba(255, 213, 210, 1)" },
  { label: "orange", color: "rgba(255, 107, 0, 1)" },
  { label: "brown", color: "rgba(157, 101, 48, 1)" },
  { label: "yellow", color: "rgba(255, 230, 0, 1)" },
  { label: "green", color: "rgba(76, 175, 80, 1)" },
  { label: "blue", color: "rgba(77, 136, 223, 1)" },
  { label: "cyan", color: "rgb(0, 255, 255)" },
  { label: "purple", color: "rgba(144, 68, 180, 1)" },
  { label: "white", color: "white" },
  { label: "grey", color: "rgba(203, 203, 203, 1)" },
  { label: "black", color: "black" },
];
function ColorPicker({ selectedColor, onSelectColor }) {
  return (
    <div style={{ height: "200px", width: "272px", padding: "20px" }}>
      <div
        style={{ marginBottom: "16px", fontSize: "16px", fontWeight: "400" }}
      >
        Vehicle Color
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          style={{
            height: "100%",
            width: "48px",
            alignSelf: "center",
          }}
        >
          <SvgVehicle />
        </div>
        <div
          style={{
            height: "100%",
            width: "152px",
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "8px",
          }}
        >
          {vehicleColors.map((item) => (
            <div
              onClick={() => onSelectColor(item.label)}
              style={{
                height: "32px",
                width: "32px",
                backgroundColor: item.color,
                borderRadius: "4px",
                cursor: "pointer",
                textAlign: "center",
                alignContent: "center",
                border:
                  item.color === "white"
                    ? "1px solid rgba(189, 189, 189, 1)"
                    : "none",
              }}
            >
              {selectedColor === item.label && (
                <CheckOutlined
                  style={{ color: item.label === "white" ? "black" : "white" }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default function MagicSearchInput({
  searchType,
  onSearchTypeChange = (e) => {},
  onAlertTimeChange = (e) => {},
  doSearch = (...args: any[]) => {},
  searchText = "",
  onSearchTextChange = (e) => {},
  collapsed = false,
  onCollapseChange = (e) => {},
  vehicleSearchParams = { brand: "", model: "", color: "", lpn: "" },
  onVehicleSearchParamsChange = (e) => {},
  showCollapse = true,
  dropdownDisabled = false,
  imgBlobSrc = null,
  onImgClose = () => {},
  styles = null,
}) {
  //danger is used to highlight the selected search type
  const [imgSearchModalOpen, setImgSearchModalOpen] = useState(false);
  const items: MenuItem[] = React.useMemo(
    () => [
      {
        key: "magic",
        danger: searchType === "magic",
        onClick: () => onSearchTypeChange("magic"),
        label: (
          <div
            style={{
              width: "149px",
              display: "flex",
              paddingTop: "7px",
              justifyContent: "start",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <SvgGPTSearch width={22} />
            <span style={{ fontWeight: "400", fontSize: "16px" }}>
              Magic Search
            </span>
          </div>
        ),
      },
      {
        key: "magicV2",
        danger: searchType === "magicV2",
        onClick: () => onSearchTypeChange("magicV2"),
        label: (
          <div
            style={{
              width: "160px",
              display: "flex",
              paddingTop: "7px",
              justifyContent: "start",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <SvgGPTSearch width={22} />
            <span style={{ fontWeight: "400", fontSize: "16px" }}>
              Magic Search V2
            </span>
          </div>
        ),
      },
      {
        key: "lpr",
        danger: searchType === "lpr",
        onClick: () => onSearchTypeChange("lpr"),
        label: (
          <div
            style={{
              width: "149px",
              display: "flex",
              paddingTop: "7px",
              justifyContent: "start",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <SvgMagicVehicle />
            <span style={{ fontWeight: "400", fontSize: "16px" }}>
              Search LPR
            </span>
          </div>
        ),
      },
      {
        key: "imageSearch",
        //danger: searchType === "magicV2",
        onClick: () => setImgSearchModalOpen(true),
        label: (
          <div
            style={{
              width: "160px",
              display: "flex",
              paddingTop: "7px",
              justifyContent: "start",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <SvgSeachImg width={25} />
            <span style={{ fontWeight: "400", fontSize: "16px" }}>
              Image Search
            </span>
          </div>
        ),
      },
    ],
    [searchType],
  );
  // preses enter key on search input
  function handleKeyDown(e) {
    if (e.key === "Enter") {
      onAlertTimeChange("allTime");
      doSearch("allTime");
    }
  }

  return (
    <div
      className="colorBorder rounded-xl flex"
      style={{
        width: styles?.width || "400px",
        backgroundColor: "white",
        height: "46px",
      }}
    >
      <Dropdown
        menu={{ items }}
        placement="bottom"
        arrow={false}
        disabled={dropdownDisabled}
      >
        <button
          style={{
            display: "inline",
            justifyItems: "center",
            marginRight: "8px",
            backgroundColor: "rgba(220, 231, 253, 1)",
            height: "30px",
            width: "30px",
            margin: "8px 0px 0px 8px",
            flex: "none",
          }}
          className="flex items-center rounded-xl"
        >
          {searchType === "magic" ? (
            <SvgGPTSearch style={{ cursor: "pointer" }} width={22} />
          ) : searchType === "magicV2" ? (
            <SvgGPTSearch style={{ cursor: "pointer" }} width={22} />
          ) : searchType === "lpr" ? (
            <SvgMagicVehicle style={{ cursor: "pointer" }} width={22} />
          ) : (
            <SvgGPTSearch style={{ cursor: "pointer" }} width={22} />
          )}
        </button>
      </Dropdown>

      {searchType === "magic" || searchType === "magicV2" ? (
        <Input
          value={searchText}
          style={{ height: "46px", boxShadow: "none", border: "none" }}
          className="colorBorder peer  w-full rounded-2xl py-[8px] pl-3 text-sm outline-none placeholder:text-gray-500 "
          placeholder={"Magic Search" + (searchType === "magicV2" ? " V2" : "")}
          onChange={(e) => onSearchTextChange(e.target.value)}
          onKeyDown={handleKeyDown}
          suffix={
            <>
              <CloseOutlined
                style={{ cursor: "pointer", marginRight: "8px" }}
                onClick={() => onSearchTextChange("")}
              />
              {showCollapse && (
                <>
                  {" "}
                  <span
                    style={{
                      display: "inline-block",
                      height: "100%",
                      margin: "0px",
                      borderRight: "1px solid rgba(225, 225, 225, 1)",
                    }}
                  ></span>
                  <button
                    style={{
                      display: "inline",
                      justifyItems: "center",
                      transition: "all 0.3s",
                      transform: collapsed ? "rotate(180deg)" : "",
                    }}
                    className="flex items-center rounded-xl    min-w-[30px] h-[30px]" //hover:bg-zinc-200
                    onClick={() => onCollapseChange(!collapsed)}
                  >
                    <DownOutlined />
                  </button>
                </>
              )}
            </>
          }
        />
      ) : searchType === "lpr" ? (
        <div
          style={{ height: "46px", display: "flex", alignItems: "center" }}
          className="w-full rounded-2xl py-[8px] pl-3"
          onKeyDown={handleKeyDown}
        >
          <input
            value={vehicleSearchParams.brand}
            onChange={(e) =>
              onVehicleSearchParamsChange((state) => {
                return { ...state, brand: e.target.value };
              })
            }
            className="outline-none placeholder:text-gray-500"
            style={{ width: "62px" }}
            placeholder="Brand"
          />
          <div
            style={{
              height: "14px",
              borderRight: "1px solid rgba(189, 189, 189, 1)",
              margin: "0px 8px",
            }}
          ></div>
          <input
            value={vehicleSearchParams.model}
            onChange={(e) =>
              onVehicleSearchParamsChange((state) => {
                return { ...state, model: e.target.value };
              })
            }
            className="outline-none placeholder:text-gray-500"
            style={{ width: "63px" }}
            placeholder="Model"
          />
          <div
            style={{
              height: "14px",
              borderRight: "1px solid rgba(189, 189, 189, 1)",
              margin: "0px 8px",
            }}
          ></div>
          <div
            style={{
              width: "46px",
              height: "28px",
              borderRadius: "8px",
              display: "flex",
              justifyContent: "space-around",
            }}
            className="hover:bg-gray-100"
          >
            <ConfigProvider
              theme={{
                components: {
                  Popover: {
                    colorBgElevated: "#FFFFFF",
                    colorText: "#000000",
                  },
                },
              }}
            >
              <Popover
                placement="bottom"
                title=""
                content={
                  <ColorPicker
                    selectedColor={vehicleSearchParams.color}
                    onSelectColor={(color) => {
                      onVehicleSearchParamsChange((state) => {
                        return { ...state, color };
                      });
                      doSearch(null, { ...vehicleSearchParams, color });
                    }}
                  />
                }
              >
                <button
                  className="text-gray-500" //hover:bg-zinc-200
                >
                  {vehicleSearchParams.color ? (
                    <div
                      style={{
                        height: "16px",
                        width: "16px",
                        borderRadius: "4px",
                        border:
                          vehicleSearchParams.color === "white"
                            ? "1px solid rgba(189, 189, 189, 1)"
                            : "none",
                        backgroundColor: vehicleColors.find(
                          (item) => item.label === vehicleSearchParams.color,
                        ).color,
                      }}
                    />
                  ) : (
                    " Color"
                  )}
                </button>
              </Popover>
            </ConfigProvider>
            {vehicleSearchParams.color && (
              <CloseOutlined
                style={{ cursor: "pointer" }}
                onClick={() => {
                  delete vehicleSearchParams.color;
                  const newvehicleSearchParams = { ...vehicleSearchParams };
                  onVehicleSearchParamsChange(() => newvehicleSearchParams);
                  doSearch(newvehicleSearchParams);
                }}
              />
            )}
          </div>
          <div
            style={{
              height: "14px",
              borderRight: "1px solid rgba(189, 189, 189, 1)",
              margin: "0px 8px",
            }}
          ></div>
          <input
            value={vehicleSearchParams.lpn}
            onChange={(e) => {
              onVehicleSearchParamsChange((state) => {
                return { ...state, lpn: e.target.value };
              });
            }}
            className="outline-none placeholder:text-gray-500"
            style={{ width: "63px", boxShadow: "none" }}
            placeholder="LPN"
          />
          <CloseOutlined
            style={{
              cursor: "pointer",
              marginRight: "8px",
              fontSize: "14px",
              marginLeft: "1px",
            }}
            onClick={() =>
              onVehicleSearchParamsChange({
                lpn: "",
                color: "",
                brand: "",
                model: "",
              })
            }
          />
          {showCollapse && (
            <>
              <span
                style={{
                  display: "inline-block",
                  height: "100%",
                  margin: "0px",
                  borderRight: "1px solid rgba(225, 225, 225, 1)",
                }}
              ></span>
              <button
                style={{
                  display: "inline",
                  justifyItems: "center",
                  transition: "all 0.3s",
                  transform: collapsed ? "rotate(180deg)" : "",
                  marginBottom: "2px",
                }}
                className="flex items-center rounded-xl    min-w-[30px] h-[30px]" //hover:bg-zinc-200
                onClick={() => onCollapseChange(!collapsed)}
              >
                <DownOutlined style={{ fontSize: "14px" }} />
              </button>
            </>
          )}
        </div>
      ) : (
        <div className="flex items-center bg-[#F5F5F5] rounded-lg gap-2 my-1 ml-2 text-base text-[#222222]">
          {imgBlobSrc && (
            <img
              src={imgBlobSrc}
              className="object-contain rounded-lg max-w-[38px] max-h-[38px]"
            />
          )}
          Selected Region
          <div
            className="ml-4 mr-2 cursor-pointer fill-neutral-500 hover:fill-neutral-400 "
            onClick={onImgClose}
          >
            <SvgClose width={"16"} className="" />
          </div>
        </div>
      )}
      <ImgSearchModalControl
        title="Upload Image"
        isOpen={imgSearchModalOpen}
        onRequestClose={() => setImgSearchModalOpen(false)}
      />
    </div>
  );
}
